// extracted by mini-css-extract-plugin
export default {"navList":"NavList_navList__Pm4Fx","active":"NavList_active__1Doyh"};